(ns manage.export-ocp.db
  (:require [cljs.core.match :refer-macros [match]]
            [clojure.string :as str]
            [common.db.interceptors :refer [forwarded-event]]
            [common.form.core :as form]
            [common.queries :refer [use-query]]
            [common.resource.query.adserver :as adserver.q]
            [common.resource.query.adserver-account-configuration :as adserver-config.q]
            [re-frame.core :as rf]
            [uix.core :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(def entity-name "Export")

(def initial-state {:exportType :manual
                    :adserverId nil
                    :adserveraccountconfigurationId nil})

(def forward-events [{:events #{:resource.export/post-success}
                      :dispatch-to [:form.adset-export/export-success]}
                     {:events #{:resource.export/post-failure}
                      :dispatch-to [:form.adset-export/export-failure]}

                     {:events #{:resource.content-function/publish-stage-success}
                      :dispatch-to [:form.adset-export/publish-stage-success]}
                     {:events #{:resource.content-function/publish-stage-failure}
                      :dispatch-to [:form.adset-export/publish-stage-failure]}

                     {:events #{:resource.adform-campaigns/success}
                      :dispatch-to [:form.adset-export/get-adform-campaigns-success]}
                     {:events #{:resource.adform-campaigns/failure}
                      :dispatch-to [:form.adset-export/get-adform-campaigns-failure]}])

(defn- on-change-form
  "Update db when an on-change event occurs.
   Reset `adserveraccountconfigurationId` when input adserverId changes"
  [db path _]
  (match [path]
    [([:adserverId] :seq)]
    (assoc-in db [:form.adset-export :value] (-> (get-in db [:form.adset-export :value])
                                                 (assoc :adserveraccountconfigurationId nil)
                                                 (assoc :adformCampaignId nil)
                                                 (dissoc :extraQuery)))
    [([:adserveraccountconfigurationId] :seq)]
    (assoc-in db [:form.adset-export :value :adformCampaignId] nil)
    :else db))

(defmulti dispatch-post-event :export-type)

(defmethod dispatch-post-event :manual [{:keys [db]}]
  (let [adset-name (get-in db [:resource.adset/one  :value :name])
        value (-> db
                  (get-in [:form.adset-export :value])
                  (assoc :exportType :manual))
        export-name (:exportName value)
        payload (cond-> (select-keys value [:adserverId
                                            :adserveraccountconfigurationId
                                            :exportType
                                            :extraQuery])
                  (and ((complement str/blank?) export-name)
                       (not= export-name adset-name))

                  (assoc :exportName export-name))]
    [:resource.export/post payload]))

(defmethod dispatch-post-event :direct [{:keys [db]}]
  (let [adset-name (get-in db [:resource.adset/one  :value :name])
        value (-> db
                  (get-in [:form.adset-export :value])
                  (assoc :exportType :direct))
        export-name (:exportName value)
        payload-keys (if (= :adform (adserver.q/adserver-type-from-id (:adserverId value)))
                       [:adserveraccountconfigurationId
                        :adformCampaignId
                        :exportType]
                       [:adserveraccountconfigurationId
                        :exportType
                        :extraQuery])
        payload (cond-> (select-keys value payload-keys)
                  (and ((complement str/blank?) export-name)
                       (not= export-name adset-name))

                  (assoc :exportName export-name))]
    [:resource.export/post payload]))

;; Events

(rf/reg-event-fx :form.adset-export/submit-form
  (fn [{:keys [db]} [_ _ exportType]]
    {:dispatch-n [[:loader/open]
                  (dispatch-post-event {:db db :export-type exportType})]}))

(rf/reg-event-fx :form.adset-export/export-failure
  [forwarded-event]
  (fn [event [_ response]]
    (let [no-pub-cfn? (= ["no-published-content-function"]
                         (get-in response [:value :error :spec]))]
      (if no-pub-cfn?
        {:dispatch [:resource.content-function/publish-stage "draft"]}
        {:dispatch-n [[:loader/close]
                      [:response-handler/handle-response
                       {:entity-name entity-name
                        :type :error
                        :event event
                        :response response}]]}))))

(rf/reg-event-fx :form.adset-export/export-success
  [forwarded-event]
  (fn [_ [_ export]]
    (let [errors (filter #(= "error" (:status %)) (get-in export [:templateExports]))
          state (if (empty? errors) :success :error)
          message (if (= :success state) "Adset exported successfully." "Export (partially) failed.")]
      {:fx [[:dispatch [:ocp/close]]
            [:dispatch [:loader/close]]
            [:dispatch [:modal/open {:id :page.export-display/last-export-result
                                     :props {:export-result export}}]]
            [:dispatch [:response-handler/handle-response
                        {:entity-name entity-name
                         :type :success
                         :message message}]]
            [:invalidate-queries {:queryKey ["adset-exports-history"]}]]})))

(rf/reg-event-fx :form.adset-export/publish-stage-failure
  [forwarded-event]
  (fn [event [_ response]]
    {:dispatch-n [[:loader/close]
                  [:response-handler/handle-response
                   {:entity-name entity-name
                    :type :error
                    :event event
                    :message (if (= 404 (:status response))
                               "You need to configure some content before you can export."
                               "Something went wrong unexpectedly.")
                    :response response}]]}))

(rf/reg-event-fx :form.adset-export/publish-stage-success
  (fn [{:keys [db]} _]
    {:dispatch-n [[:loader/close]
                  (dispatch-post-event {:db db :export-type :direct})]}))

(rf/reg-event-fx :form.adset-export/get-adform-campaigns
  [(rf/inject-cofx :sub :form.adset-export/is-adform?)]
  (fn [{:keys [form.adset-export/is-adform?]} [_ config-id campaign-filter]]
    (when (and is-adform? (some? config-id))
      {:fx [[:dispatch [:resource.adform-campaigns/get-campaigns-for-advertiser config-id (when-not (str/blank? campaign-filter)
                                                                                            campaign-filter)]]]})))

(rf/reg-event-fx :form.adset-export/get-adform-campaigns-success
  (fn [_ [_ [_ _campaigns]]]))

(rf/reg-event-fx :form.adset-export/get-adform-campaigns-failure
  (fn [_ [event response]]
    {:dispatch [:response-handler/handle-response
                {:entity-name entity-name
                 :type :error
                 :event event
                 :message "Could not retrieve campaigns"
                 :response response}]}))

;; Subscriptions

(rf/reg-sub :form.adset-export/is-adform?
  :<- [:form.adset-export/value [:adserverId]]
  (fn [adserver-id _]
    (= :adform (adserver.q/adserver-type-from-id adserver-id))))

(rf/reg-sub :form.adset-export/is-cm-360?
  :<- [:form.adset-export/value [:adserverId]]
  (fn [adserver-id _]
    (= :dcm (adserver.q/adserver-type-from-id adserver-id))))

(rf/reg-sub :form.adset-export/adform-campaign-list
  :<- [:resource.adform-campaigns/current]
  (fn [{adform-campaigns :value} _]
    (->> adform-campaigns
         (map (fn [{:keys [id name]}]
                {:value id
                 :label name})))))

(rf/reg-sub :form.adset-export/adform-campaign-status
  :<- [:resource.adform-campaigns/current]
  (fn [current _]
    (:state current)))

(rf/reg-sub :form.adset-export/adform-export-target
  :<- [:form.adset-export/is-adform?]
  :<- [:form.adset-export/value [:adformCampaignId]]
  :<- [:form.adset-export/value [:adserveraccountconfigurationId]]
  (fn [[is-adform? campaign-id export-target] _]
    (if is-adform?
      (and (some? export-target) (some? campaign-id))
      (some? export-target))))

(defhook use-target-export-options []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {adserver-configs :data} (use-query (adserver-config.q/adserver-account-configurations-query
                                             {:advertiser-id advertiser-id}))
        adserver-id (use-subscribe [:form.adset-export/value [:adserverId]])]
    (->> adserver-configs
         (filter #(= adserver-id (get-in % [:adserveraccount :adserver :id])))
         (map #(hash-map :label (get-in % [:adserveraccount :name])
                         :value (:id %))))))

(rf/reg-event-db :form.adset-export/set-export-name
  (fn [db [_ _ export-name]]
    (-> db
        (assoc-in [:form.adset-export :value :exportName] export-name))))

(def use-bind-control (partial form/use-bind-control :form.adset-export))

(form/register-form {:namespace :form.adset-export
                     :initial-value initial-state
                     :forward-events forward-events
                     :submit-event :form.adset-export/submit-form
                     :on-change on-change-form})
